import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import style from './style.module.scss'

const ModalAgenticPricingThankYou = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'agenticPricingThankYou'
  const visible = modalID === visibleModalID

  return (
    <Modal
      className={style.thankYouModal}
      onCancel={handleClose}
      afterClose={handleClose}
      open={visible}
      footer={null}
      maskClosable={false}
      centered
      width={400}
    >
      <div className={style.modalContent}>
        <div className={style.iconWrapper}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={style.checkIcon}
            aria-hidden="true"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h2 className={style.title}>Thank you for your interest!</h2>
        <p className={style.subtitle}>Our team will get back to you shortly.</p>
        <ButtonPurple
          buttonText="Got it"
          onClick={handleClose}
          holderStyles={{ width: '100%', marginBottom: 0, justifyContent: 'center' }}
        />
      </div>
    </Modal>
  )
}

export default ModalAgenticPricingThankYou
